<h4 class="ms-2 mt-2 mb-6">Main vehicle stress factors</h4>
<div class="row gx-3 ms-2 me-2 mt-1 mb-1 ps-0 pe-0" [ngClass]="getStressFactorsRowClass()">
	<ng-container *ngIf="stressFactors?.length; else noData">
		<div class="col ms-0 me-0 ps-custom pe-custom" *ngFor="let sf of stressFactors">
			<div class="shaded-container shaded-container-box ag-shaded-container ag-shaded-container-box mb-2 p-1 d-flex flex-column flex-fill h-100">
				<div class="progress-container-position">
					<app-circular-progress
						[percentage]="sf.score ?? 0"
						[label]="sf.rating"
						[labelColor]="getColor(sf.rating)"
						[progressColor]="getColor(sf.rating)"
						[zones]="getZones([0, 60, 80, 100])"
						[backgroundStrokeWidth]="20"
						[progressStrokeWidth]="5"
					></app-circular-progress>
				</div>
				<div [ngStyle]="{ 'background': getBgColor(sf.stressFactorName) }" class="feature-background-image">
					<ng-container [ngSwitch]="sf.stressFactorName?.trim()">
							<img *ngSwitchCase="'Share of Fast Charging Sessions'" [src]="imageUrls.eCharging" alt="Share of Fast Charging Sessions" class="feature-icon" />
							<img *ngSwitchCase="'Charging at Low Temperatures'" [src]="imageUrls.eChargingStationIce" alt="Charging at Low Temperatures" class="feature-icon" />
							<img *ngSwitchCase="'State of Charge > 80%'" [src]="imageUrls.battery" alt="State of Charge > 80%" class="feature-icon" />
							<img *ngSwitchCase="'State of Charge (SoC) > 80%'" [src]="imageUrls.battery" alt="State of Charge (SoC) > 80%" class="feature-icon" />
							<img *ngSwitchCase="'High Battery Temperature'" [src]="imageUrls.batteryTemperature" alt="High Battery Temperature" class="feature-icon" />
							<img *ngSwitchDefault [src]="imageUrls.eCharging" alt="Icon" class="feature-icon" />
						</ng-container>
				</div>
				<p><strong>{{ sf.stressFactorName }}</strong></p>
				<h5 class="ag-loss-row">
					<span>Avoidable Range Loss: {{ formatLoss(sf.deltaScore) }}</span>
					<span *ngIf="sf.warningIcon" class="ag-warning-icon rb-ic rb-ic-alert-warning-filled" aria-hidden="true"></span>
				</h5>
			</div>
		</div>
	</ng-container>
	<ng-template #noData>
        <div class="col-12">
            <rb-callout type="warning">
                No stress factor data.
            </rb-callout>
        </div>
	</ng-template>
</div>
